export const getSearchThemeDetails = (i18n, searchThemes) => {
  const selected = searchThemes && searchThemes.filter(item => item.Status !== 'Deleted');
  if (selected && selected.length > 0) {
    return selected.map(item => item.SearchTheme).join(', ');
  }
  return i18n.getString(_TL_('No search themes added'));
};
